
import {
  arrayOf,
  bool,
  nullable,
  object,
  oneOfType,
  shape,
  string,
} from 'vue-types';
export default {
  inheritAttrs: false,
  props: {
    nextBg: oneOfType([string(), nullable()]),
    nextSpacing: bool().def(false),
    introduction: oneOfType([string(), nullable()]),
    steps: arrayOf(
      shape({
        label: oneOfType([string(), nullable()]),
        heading: oneOfType([string(), nullable()]),
        body: oneOfType([string(), nullable()]),
        footerText: oneOfType([string(), nullable()]),
        boxed: bool().def(false),
        cards: arrayOf(object()),
      }).loose
    ).def([]),
  },
  data() {
    return {};
  },
  computed: {
    viewportHeight() {
      return this.$store.state.viewport.height;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.setLineBottom();
      this.setBallPositions();
    });
    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onResize() {
      this.setLineBottom();
      this.setBallPositions();
    },
    onScroll() {
      const { line, lineContainer, balls } = this.$refs;
      if (line && lineContainer) {
        const scrollPosition = window.scrollY + window.innerHeight / 2;
        const height = Math.min(
          lineContainer.offsetHeight,
          scrollPosition -
            (lineContainer.getBoundingClientRect().top + window.scrollY)
        );
        line.style.maxHeight = `${height}px`;

        if (balls) {
          for (const ball of balls) {
            if (ball.getBoundingClientRect().top <= window.innerHeight / 2) {
              ball.style.transform = 'scale(1.75)';
              ball.classList.add('bg-blue-500');
              ball.classList.remove('bg-gray-100');
            } else {
              ball.style.transform = 'scale(1)';
              ball.classList.add('bg-gray-100');
              ball.classList.remove('bg-blue-500');
            }
          }
        }
      }
    },
    setLineBottom() {
      const { lineContainer, steps } = this.$refs;

      if (lineContainer && steps) {
        const lastStep = steps[steps.length - 1];
        const offset = lastStep.classList.contains('boxed') ? 32 : 4;
        lineContainer.style.bottom = `${lastStep.offsetHeight - offset}px`;
      }
    },
    setBallPositions() {
      const { balls, steps, lineContainer } = this.$refs;

      if (balls && steps && lineContainer) {
        for (let i = 0; i < steps.length; i++) {
          const step = steps[i];
          const offset = step.classList.contains('boxed') ? 32 : 4;
          balls[i].style.top = `${
            step.offsetTop - lineContainer.offsetTop + offset
          }px`;
        }
      }
    },
  },
};
